import slugify from '../../../utils/string/slugify.js'

/**
 * Generates a slug from a source field and writes it to a target field.
 * Removes whitespace, uppercases, and trims to maxLength.
 *
 * Tracks the source as the user types — keeps updating as long as the target
 * looks auto-generated (matches slugify of the previous source value).
 * Stops updating once the target has been manually edited to something different.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.slugField',
 *     sourceField: 'name',
 *     targetField: 'sku'
 * }
 */
const headerSlugField = (data, operation, prevData = {}) => {
    const { sourceField, targetField } = operation

    if (!sourceField || !targetField) return data

    const source = data[sourceField]
    if (!source || typeof source !== 'string') return data

    const currentTarget = data[targetField] || ''
    const prevSource = prevData[sourceField] || ''

    if (!currentTarget) {
        return { ...data, [targetField]: slugify(source) }
    }

    if (currentTarget === slugify(prevSource)) {
        return { ...data, [targetField]: slugify(source) }
    }

    return data
}

export default headerSlugField
